/**
 * @generated SignedSource<<cf6259b63cb00ba8c85546aae9313bee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StorefrontProfilesStatus = "DELETED" | "LIVE" | "PENDING_TRANSLATION" | "REJECTED" | "UNDER_REVIEW" | "WORK_IN_PROGRESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedStorefrontLink_browseContentModule$data = {
  readonly seller: {
    readonly liveStorefrontProfile: {
      readonly status: StorefrontProfilesStatus | null;
    } | null;
    readonly sellerPreferences: {
      readonly urlLabel: string | null;
    } | null;
    readonly sellerProfile: {
      readonly company: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "SbSharedStorefrontLink_browseContentModule";
};
export type SbSharedStorefrontLink_browseContentModule$key = {
  readonly " $data"?: SbSharedStorefrontLink_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedStorefrontLink_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedStorefrontLink_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerProfile",
          "kind": "LinkedField",
          "name": "sellerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerPreferences",
          "kind": "LinkedField",
          "name": "sellerPreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleRegular",
  "abstractKey": null
};

(node as any).hash = "33371f7c2872d7c508fd91f7f41a542e";

export default node;
